import mergewith from 'lodash.mergewith';
import merge from 'lodash.merge';
import sum from 'lodash.sum';
export const mergeDeepSum = (objValue, srcValue) => {
    if (typeof objValue === 'number' && typeof srcValue === 'number') {
        return sum([objValue, srcValue]);
    }
    else if (Array.isArray(objValue) && Array.isArray(srcValue)) {
        const newArray = srcValue.map((i, idx) => sumAllProps(objValue?.[idx], srcValue?.[idx]));
        return newArray;
        /* if (typeof srcValue?.[0] === 'number') {
          const newArray: Array<number> = srcValue.map((i, idx) =>
            sum([objValue?.[idx], srcValue?.[idx]]),
          );
          return newArray;
        } else {
          const newArray: Array<object> = srcValue.map((i, idx) =>
            sumAllProps(objValue?.[idx], srcValue?.[idx]),
          );
          return newArray;
        } */
    }
};
export const sumAllProps = (toObject, fromObject) => {
    return merge({}, mergewith(merge({}, toObject || {}), fromObject, mergeDeepSum));
};
export const updateOrPush = (array = [], obj, key) => {
    const idx = array.findIndex((i) => i[key] === obj[key]);
    if (idx >= 0) {
        merge(array[idx], obj);
    }
    else {
        array.push(obj);
    }
    return array;
};
